import { render } from "./VideoHelpLink.vue?vue&type=template&id=13b2c2d9&scoped=true&ts=true"
import script from "./VideoHelpLink.vue?vue&type=script&lang=ts"
export * from "./VideoHelpLink.vue?vue&type=script&lang=ts"

import "./VideoHelpLink.vue?vue&type=style&index=0&id=13b2c2d9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b2c2d9"]])

export default __exports__